import { useEffect, useState, useRef } from "react";
import Dropdown from "../components/dropdown";
import DownIcon from "../icons/down";
import UpIcon from "../icons/up";
import Button from "./button";

type Options = string;

interface Props {
  block?: boolean;
  value: string;
  options: Options[];
  textPrefix?: string;
  valueChanged: (value: string) => void;
  titleCaseOptions?: boolean;
  direction?: "up" | "down";
}

export default function Select({
  block,
  value,
  options,
  textPrefix,
  valueChanged,
  titleCaseOptions,
  direction = "down",
}: Props) {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(value);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const updatedSelected = (value: string) => {
    setIsOpen(false);
    setSelected(value);
    valueChanged(value);
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target as Node)
    ) {
      setIsOpen(false);
    }
  };

  function toTitleCase(str: string) {
    let strArr = str.toLowerCase().split(" ");
    for (var i = 0; i < strArr.length; i++) {
      strArr[i] = strArr[i].charAt(0).toUpperCase() + strArr[i].slice(1);
    }
    return strArr.join(" ");
  }

  useEffect(() => {
    setSelected(value);
  }, [value]);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="relative" ref={dropdownRef}>
      <Button onClick={toggleDropdown} icon block={block}>
        <span>
          {textPrefix && `${textPrefix} `}
          {titleCaseOptions ? toTitleCase(selected) : selected}
        </span>
        {direction === "up" ? <UpIcon /> : <DownIcon />}
      </Button>
      {isOpen && (
        <Dropdown
          options={options}
          optionClicked={updatedSelected}
          titleCaseOptions={titleCaseOptions}
          direction={direction}
        />
      )}
    </div>
  );
}
